import { render, staticRenderFns } from "./TotalstandNoHo.vue?vue&type=template&id=089cb702&scoped=true&"
import script from "./TotalstandNoHo.vue?vue&type=script&lang=js&"
export * from "./TotalstandNoHo.vue?vue&type=script&lang=js&"
import style0 from "./TotalstandNoHo.vue?vue&type=style&index=0&id=089cb702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089cb702",
  null
  
)

export default component.exports